export class MetaEntityRequestDto {
    listByAliases: string[];
    listByIds: number[];
    extractAttributes: boolean;
    extractJoins: boolean;
    extractGenericTypes: boolean;
}